import { LayoutOrientation } from '@ardoq/yfiles';
import type { ModernizedBlockDiagramConfig } from './types';

export const EMBEDDED_MODERNIZED_BLOCK_DIAGRAM_CONFIG: ModernizedBlockDiagramConfig =
  {
    isPresentationMode: false,
    isCanvasPrototype: false,
  };

export const BLOCK_DIAGRAM_LAYOUT_OPTIONS: [
  string,
  LayoutOrientation,
  string,
][] = [
  [
    'Left to right',
    LayoutOrientation.LEFT_TO_RIGHT,
    'appLayout:viewPaneHeader.leftToRight',
  ],
  [
    'Right to left',
    LayoutOrientation.RIGHT_TO_LEFT,
    'appLayout:viewPaneHeader.rightToLeft',
  ],
  [
    'Top to bottom',
    LayoutOrientation.TOP_TO_BOTTOM,
    'appLayout:viewPaneHeader.topToBottom',
  ],
  [
    'Bottom to top',
    LayoutOrientation.BOTTOM_TO_TOP,
    'appLayout:viewPaneHeader.bottomToTop',
  ],
];
